import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ShopSettingsService } from '../../general/services/shop-settings.service';

@Injectable()
export class PartnerCodePageGuard implements CanActivate {

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      if (this.shopSettingsService.shopSettings.partnerCodePayment) {
        return true;
      }

    return false;
  }
}
